module.exports = __webpack_public_path__ + "static/media/medal-silver.9320dfec.png";